import request from '@/utils/request'

export const investigationPaperList = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperList`, method: 'post', data })

export const investigationPaperIns = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperIns`, method: 'post', data })

export const investigationPaperUpd = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperUpd`, method: 'post', data })

export const investigationPaperDel = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperDel`, method: 'post', data })

export const investigationPaperDelBatch = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperDelBatch`, method: 'post', data })

export const investigationPaperPublishEdit = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperPublishEdit`, method: 'post', data })

export const investigationPaperCustomList = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperCustomList`, method: 'post', data })

export const IPCQ = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperCustomAndQuestionIns`, method: 'post', data })

export const paperUnSubmitList = (data = {}) => request({ url: `/api/community/v1/community/paperUnSubmitList`, method: 'post', data })

export const investigationPaperAnswerAnalysis = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperAnswerAnalysis`, method: 'post', data })

export const investigationPaperAnswerAnalysisFIll = (data = {}) => request({ url: `/api/community/v1/community/investigationPaperAnswerAnalysisFIll`, method: 'post', data })

export const investigationCopy = (data = {}) => request({ url: `/api/community/v1/community/investigationCopy`, method: 'post', data })

export const investigationAnswerSheetList = (data = {}) => request({ url: `/api/community/v1/community/investigationAnswerSheetList`, method: 'post', data })

export const investigationAnswerSheetCount = (data = {}) => request({ url: `/api/community/v1/community/investigationAnswerSheetCount`, method: 'post', data })

export const investigationAnswerSheetDel = (data = {}) => request({ url: `/api/community/v1/community/investigationAnswerSheetDel`, method: 'post', data, timeout: 70_000 })

export const investigationAnswerCustomDetail = (data = {}) => request({ url: `/api/community/v1/community/investigationAnswerCustomDetail`, method: 'post', data })

// 已完成
